import React, { Component } from 'react';
import { MultiDropdownList } from '@appbaseio/reactivesearch';
import MultiDropdownListWithFocus from '../../components/MultiDropdownListWithFocus';

class Period extends Component {
  render() {
    return (
      <div className="period">
        <MultiDropdownList
          title="Period"
          className="form-field"
          componentId="Period"
          dataField={"Period.keyword"}
          size={100}
          showCount={false}
          showSearch={true}
          sortBy="asc"
          renderListItem={label => (
            <div>{label !== "NULL" ? label : "None"}</div>
          )}
          placeholder={this.props.appType === "original" ? "Select values" : ""}
        />
      </div>
    );
  }
}

export default MultiDropdownListWithFocus(Period);